<template>
  <h2>Plan-Anmerkungen</h2>
  <router-link :to="{name: 'Plan', params: {id: this.scheduleId}}" class="link-secondary"><em
      class="align-middle material-icons">arrow_back_ios</em> Zurück zum Plan
  </router-link>

  <VueDataTable :cols="[
                  {title: 'Datum & Uhrzeit', key: 'datetime', type: 'datetime'},
                  {title: 'Text', key: 'text', type: 'inject'},
                  {title: 'Fett drucken?', key: 'bold', type: 'checkbox'},
                  {title: 'Bild', key: 'image', type: 'inject'},
                  {title: 'Bildbreite [mm]', key: 'imageWidth', type: 'inject'},
                  {title: 'Datum anzeigen?', key: 'showDate', type: 'checkbox'},
                  {title: 'Uhrzeit anzeigen?', key: 'showTime', type: 'checkbox'},
                  {type: 'inject', key: 'edit'},
                  {type: 'inject', key: 'delete'},
                ]"
                :data="scheduleAnnotationStore.scheduleAnnotationsForSchedule(this.scheduleId)"
                :store="scheduleAnnotationStore"
                caption="Liste aller Plan-Anmerkungen"
                @update="el => this.scheduleAnnotationStore.updateItem(el)">
    <template #text="{el}">
      <textarea v-model="el.text"
                :class="{'form-control-plaintext': selectedScheduleAnnotation !== el, 'fw-bold': el.bold}"
                :readonly="selectedScheduleAnnotation == null"
                :style="{color: el.color}"
                class="form-control" @click="selectedScheduleAnnotation = el"
                @focusin="selectedScheduleAnnotation = el"
                @focusout="this.updateScheduleAnnotation(el)"
                @keyup.esc="abortUpdateScheduleAnnotation"></textarea>
    </template>
    <template #image="{el}">
      <select v-if="selectedScheduleAnnotation === el"
              v-model="el.image"
              aria-label="Select Image" class="form-select"
              @focusout="this.updateScheduleAnnotation(el)"
              @keyup.esc="abortUpdateScheduleAnnotation">
        <option :value="null" selected>-</option>
        <option v-for="image in this.mediaStore.data" :key="image.id" :value="image.id">{{ image.name }}</option>
      </select>
      <img v-else-if="el.image" :alt="this.mediaStore.getItemById(el.image).name"
           :src="this.mediaStore.getItemById(el.image).relative_url" height="60"
           @click="selectedScheduleAnnotation = el">
      <em v-else class="align-middle material-icons" @click="selectedScheduleAnnotation = el">image_not_supported</em>
    </template>
    <template #imageWidth="{el}">
      <input v-if="el.image" v-model="el.imageWidth"
             :class="{'form-control-plaintext': selectedScheduleAnnotation !== el}"
             :readonly="selectedScheduleAnnotation == null"
             class="form-control"
             type="number" @click="selectedScheduleAnnotation = el"
             @focusin="selectedScheduleAnnotation = el"
             @focusout="this.updateScheduleAnnotation(el)"
             @keyup.esc="abortUpdateScheduleAnnotation">
    </template>
    <template #edit="{el}">
      <schedule-annotation-create-edit-modal :pass-in-schedule-annotation=el
                                             :schedule-id=this.scheduleId
                                             trigger-class="btn-warning" trigger-icon="edit"
                                             trigger-text=""></schedule-annotation-create-edit-modal>
    </template>
    <template #delete="{el}">
      <button class="btn btn-danger" @click="this.scheduleAnnotationStore.deleteItem(el, false)"><em
          class="align-middle material-icons">delete</em></button>
    </template>
  </VueDataTable>

  <schedule-annotation-create-edit-modal :pass-in-schedule-annotation=null :schedule-id=this.scheduleId
                                         trigger-class="btn-success" trigger-icon="edit_note"
                                         trigger-text="Neue Anmerkung anlegen"></schedule-annotation-create-edit-modal>
</template>

<script>
import ScheduleAnnotationCreateEditModal from "@/components/ScheduleAnnotationCreateEditModal.vue";
import {useMediaStore} from "@/stores/media";
import {useScheduleAnnotationStore} from "@/stores/scheduleAnnotation";
import VueDataTable from "@/components/DataTable.vue";

export default {
  name: "ScheduleAnnotations",
  data: function () {
    return {
      openCreateModal: false,
      selectedScheduleAnnotation: null,
      scheduleId: Number(this.$route.params.id),
    }
  },
  methods: {
    updateScheduleAnnotation(scheduleAnnotation) {
      this.scheduleAnnotationStore.updateItem(scheduleAnnotation);
      this.selectedScheduleAnnotation = null;
    },
    async abortUpdateScheduleAnnotation() {
      this.selectedScheduleAnnotation = null;
      await this.scheduleAnnotationStore.getScheduleAnnotations(this.scheduleId);
    },
  },
  created() {
    this.scheduleAnnotationStore.getScheduleAnnotations(this.scheduleId);
    if (!this.mediaStore.loadedData)
      this.mediaStore.getData();
  },
  setup() {
    const mediaStore = useMediaStore();
    const scheduleAnnotationStore = useScheduleAnnotationStore();
    return {mediaStore, scheduleAnnotationStore};
  },
  components: {
    VueDataTable,
    ScheduleAnnotationCreateEditModal,
  }
}
</script>
